export default class AppService {
    static place_symbol(graph, evt, cell, x, y, symbol, setSchematicElement, schematicList) {
        const pt = graph.getPointForEvent(evt);
        /**
         * Prevent drop if figure set out of background bounds
         */
        let graphAbsoluteCoordinates = graph.view.relativeCoordsToAbsolute(
            {x: pt.x * graph.view.scale, y: pt.y * graph.view.scale}
        );

        if (!graph.view.isFigureWithinBackgroundBounds({
            x: graphAbsoluteCoordinates.x,
            y: graphAbsoluteCoordinates.y,
            width: symbol.data.X_Bound * graph.view.scale,
            height: symbol.data.Y_Bound * graph.view.scale
        })) {
            return;
        }
        /******************************************************/
        graph.getModel().beginUpdate();
        try {
            const parentElement = graph.getDefaultParent();
            const geometry = new window.mxGeometry(pt.x, pt.y, symbol.data.X_Bound, symbol.data.Y_Bound);
            let symbolCell;
            if (symbol.isSpecial) {
                symbolCell = new window.CYNYConnector(geometry, 'shape=symbol_element;', symbol.data, graph, null, symbol.name, symbol.desc, symbol.id, symbol.typeId);
                symbolCell.setValue('');
            } else {
                symbolCell = new window.CYNYSymbol(geometry, 'shape=symbol_element;', symbol.data, graph, null, symbol.name, symbol.desc, symbol.id, symbol.typeId);

            }
            graph.addCell(symbolCell, parentElement);
        } finally {
            graph.getModel().endUpdate();
            if (!symbol.isSpecial) {
                const isAdded = schematicList.some(s => s.id === symbol.id);
                if (!isAdded) {
                    setSchematicElement(symbol);
                }
            }
        }
    }

    static getUpdatedSchematicJson(graph, schematicDocument) {
        const schematic = window.JSON.parse(window.JSON.stringify(schematicDocument.data));
        /**
         * Update current page data before save
         */
        const {activePage, pages} = graph.exportJson();
        schematic.activePage = activePage;
        schematic.pages = pages;
        return schematic;
    }
}